<template>
  <canvas ref="waveCanvas" class="wave-canvas"></canvas>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, watchEffect } from 'vue'

export default {
  setup() {
    const waveCanvas = ref(null)
    const animationId = ref(null)
    const height = ref(30)
    const speed = ref(0.5) // 提高整体速度
    
    // 增加波浪振幅
    const waves = ref([
      { id: 0, name: '蓝宝石', color: 'rgba(23, 84, 244, 0.3)', A: 15, W: 1 / 180, Q: 0, speed: -0.01, H: 0 },
      { id: 1, name: '翡翠绿', color: 'rgba(48, 189, 159, 0.3)', A: 28, W: 1 / 220, Q: 0, speed: -0.015, H: 0 },
      { id: 2, name: '帝王紫', color: 'rgba(216, 97, 235, 0.3)', A: 31, W: 1 / 360, Q: 0, speed: -0.02, H: 0 },
      { id: 3, name: '活力橙', color: 'rgba(254, 190, 68, 0.3)', A: 44, W: 1 / 400, Q: 0, speed: -0.025, H: 0 },
      { id: 4, name: '少女粉', color: 'rgba(120, 102, 255, 0.3)', A: 57, W: 1 / 550, Q: 0, speed: -0.03, H: 0 }
    ])
    
    const initCanvas = () => {
      const canvas = waveCanvas.value
      if (!canvas) return
      
      const dpr = window.devicePixelRatio || 1
      canvas.width = canvas.offsetWidth * dpr
      canvas.height = canvas.offsetHeight * dpr
      canvas.style.width = `${canvas.offsetWidth}px`
      canvas.style.height = `${canvas.offsetHeight}px`
      
      const ctx = canvas.getContext('2d')
      ctx.scale(dpr, dpr)
      
      const baseHeight = canvas.offsetHeight * 0.6
      waves.value.forEach(wave => {
        wave.H = baseHeight * (0.8 + Math.random() * 0.4) // 增大基线随机范围
      })
      
      startAnimation()
    }
    
    const startAnimation = () => {
      const canvas = waveCanvas.value
      if (!canvas) return
      
      const ctx = canvas.getContext('2d')
      const width = canvas.offsetWidth
      const height = canvas.offsetHeight
      
      if (animationId.value) {
        cancelAnimationFrame(animationId.value)
      }
      
      const animate = () => {
        ctx.clearRect(0, 0, width, height)
        
        waves.value.forEach(wave => {
          wave.Q += wave.speed
          
          // 增大跳动幅度和频率
          wave.H += Math.sin(Date.now() * 0.002) * 1.2 
          wave.H = Math.max(height * 0.3, Math.min(height * 0.9, wave.H)) // 扩大限制范围
          
          ctx.beginPath()
          ctx.strokeStyle = wave.color
          ctx.lineWidth = 2
          
          for (let x = 0; x <= width; x++) {
            const y = wave.A * Math.sin(wave.W * x + wave.Q) + wave.H
            if (x === 0) {
              ctx.moveTo(x, y)
            } else {
              ctx.lineTo(x, y)
            }
          }
          
          ctx.stroke()
        })
        
        animationId.value = requestAnimationFrame(animate)
      }
      
      animate()
    }
    
    const handleResize = () => {
      initCanvas()
    }
    
    const observeResize = () => {
      const canvas = waveCanvas.value
      if (!canvas) return
      
      const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          initCanvas()
        }
      })
      
      resizeObserver.observe(canvas.parentNode)
      
      return () => {
        resizeObserver.disconnect()
      }
    }
    
    onMounted(() => {
      initCanvas()
      window.addEventListener('resize', handleResize)
      observeResize()
    })
    
    onBeforeUnmount(() => {
      if (animationId.value) {
        cancelAnimationFrame(animationId.value)
      }
      window.removeEventListener('resize', handleResize)
    })
    
    return {
      waveCanvas
    }
  }
}
</script>